import React from 'react';
import Modal from './Modal';

interface RefundModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    selectedCount: number;
    title?: string;
}

const RefundModal: React.FC<RefundModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    selectedCount,
    title = 'Estornar Pagamento'
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-4">
                <div className="flex items-center space-x-3">
                    <div className="bg-orange-100 p-3 rounded-full">
                        <svg className="h-6 w-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                    </div>
                    <div>
                        <h3 className="text-lg font-medium text-secondary-900">Confirmar Estorno</h3>
                        <p className="text-sm text-secondary-600">
                            Esta ação não pode ser desfeita
                        </p>
                    </div>
                </div>

                <p className="text-secondary-700">
                    Tem certeza que deseja estornar o pagamento de {selectedCount} conta{selectedCount > 1 ? 's' : ''}?
                    {selectedCount > 1 ? ' Todas as contas selecionadas voltarão ao status pendente.' : ' Esta conta voltará ao status pendente.'}
                </p>

                <div className="bg-orange-50 border border-orange-200 rounded-md p-3">
                    <p className="text-sm text-orange-800">
                        <strong>Atenção:</strong> O estorno removerá a data de pagamento e alterará o status para pendente.
                    </p>
                </div>

                <div className="flex justify-end space-x-2 pt-4">
                    <button onClick={onClose} className="btn-secondary">
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        className="btn-primary bg-orange-600 hover:bg-orange-700 border-orange-600"
                    >
                        Confirmar Estorno
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default RefundModal;







